import gql from 'graphql-tag';
export default gql`
  mutation fetchVehicleSearchConfig($searchFilters: VehicleSearchConfigInput) {
    fetchVehicleSearchConfig(searchFilters: $searchFilters) {
      version
      country
      orgId
      generatedAt
      appliedFilters {
        make
        model
        fuelType
        drivetrain
        transmission
        bodyType
        cabType
        seats
      }
      facets {
        make
        model
        modelsByMake {
          make
          models
        }
        fuelType
        drivetrain
        transmission
        bodyType
        cabType
        vehicleCategory
        seats
      }
    }
  }
`;
